<template>
  <div class="project_box">
    <sellheader></sellheader>
    <div class="content">
      <div
        :style="{ backgroundImage: 'url(' + backgroundImg + ')' }"
        style="background-size: cover; min-height: 300px; position: relative"
        class="inner-banner"
      >
        <section class="w3l-breadcrumb">
          <div class="container">
            <ul class="breadcrumbs-custom-path">
              <li><a href="./">首页</a></li>
              <li class="active">
                <span class="fa fa-chevron-right mx-2" aria-hidden="true"></span
                >产品展示
              </li>
            </ul>
          </div>
        </section>
      </div>
      <div class="project_list">
        <!-- <div class="project_type_list">
          <ul>
            <li @click="option(0, '全部')" :class="op == 0 ? 'option' : ''">
              <div class="lit_title">
                <div class="lit_icon">
                  <i class="iconfont icon-quanbu"></i>
                </div>
                <div>全部</div>
              </div>
            </li>
            <li @click="option(1, '心脑血管')" :class="op == 1 ? 'option' : ''">
              <div class="lit_title">
                <div class="lit_icon">
                  <i class="iconfont icon-xinnaoxieguanzhiru_shenjingke"></i>
                </div>
                <div>心脑血管</div>
              </div>
            </li>
            <li @click="option(2, '慢病')" :class="op == 2 ? 'option' : ''">
              <div class="lit_title">
                <div class="lit_icon">
                  <i class="iconfont icon-manbing"></i>
                </div>
                <div>慢病</div>
              </div>
            </li>
            <li
              @click="option(3, '抗微生物药')"
              :class="op == 3 ? 'option' : ''"
            >
              <div class="lit_title">
                <div class="lit_icon">
                  <i class="iconfont icon-weishengwuweishengwujianyan"></i>
                </div>
                <div>抗微生物药</div>
              </div>
            </li>
            <li @click="option(4, '其他')" :class="op == 4 ? 'option' : ''">
              <div class="lit_title">
                <div class="lit_icon">
                  <i class="iconfont icon-qita"></i>
                </div>
                <div>其他</div>
              </div>
            </li>
          </ul>
        </div> -->
        <div class="title_text">
          {{ title_text[op] }}
        </div>

        <div class="project_all">
          <section class="w3l-blogpost-content w3l-courses py-5">
            <div class="container py-md-5">
              <div class="row">
                <div v-if="total > 0">
                  <div
                    v-for="(item, index) in projectList"
                    :key="index"
                    style="cursor: pointer; float: left"
                    class="col-lg-3 hh col-md-6 mt-4"
                  >
                    <router-link
                      :to="'/project_info' + '?projectid=' + item.id"
                    >
                      <div class="card">
                        <div class="card-header p-0 position-relative">
                          <span>
                            <img
                              class="card-img-bottom d-block radius-image-full"
                              :src="item.picUrl"
                              alt=""
                              style="width: 100%; height: 296px"
                            />
                          </span>
                        </div>
                        <div
                          style="padding: 10px; text-align: center"
                          class="card-body blog-details"
                        >
                          <p class="price-review">
                            {{ item.productName.substring(0, 15) }}
                          </p>
                        </div>
                        <div class="zhe">
                          <div class="text">
                            <p
                              class="title"
                              :style="{
                                fontSize: stringbut(item.productName) + 'px',
                              }"
                            >
                              {{ item.productName.substring(0, 11) }}
                            </p>
                            <p class="guige">规格：{{ item.specs }}</p>
                            <p>
                              <i class="iconfont icon-chakan"></i>
                            </p>
                          </div>
                        </div>
                      </div>
                    </router-link>
                  </div>
                </div>
                <div v-else>暂无产品</div>
              </div>
              <div class="course-button mt-lg-4 text-center">
                <pagination
                  v-show="total > 0"
                  :total="total"
                  :page.sync="queryParams.pageNum"
                  :limit.sync="queryParams.pageSize"
                  @pagination="getProjectList"
                ></pagination>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>

    <footers></footers>
  </div>
</template>

<script>
import sellheader from "@/views/home/header/index.vue";
import footers from "@/views/footer/index.vue";
import { projectList } from "@/api/project/index";
import { bannerList } from "@/api/menu/index.js";
export default {
  components: {
    sellheader,
    footers,
  },
  data() {
    return {
      currentPage1: 1,
      backgroundImg: "",
      op: 0,
      title_text: ["全部产品", "心脑血管", "慢病", "抗微生物药", "其他"],
      projectList: [],
      queryParams: {
        pageNum: 1,
        pageSize: 12,
        bigType: 1,
        orderByColumn: "sort",
      },
      total: 0,
      imgqueryParams: {
        picType: "project",
      },
    };
  },
  watch: {
    $route(to, from) {
      let selectId = to.query.selectid;
      if (selectId != null) {
        this.op = selectId;
        this.queryParams.bigType = selectId;
      } else {
        this.op = 0;
      }

      this.getProjectList();
    },
  },
  mounted() {
    let selectid = this.getUrlKey("selectid");
    if (selectid != null) {
      this.op = selectid;
      this.queryParams.bigType = selectid;
    } else {
      this.op = 0;
    }

    if (this.op == 0) {
      this.queryParams = {
        pageNum: 1,
        pageSize: 12,
        orderByColumn: "sort",
      };
    }
    this.getProjectList();
    this.getBannerList();
  },
  methods: {
    stringbut(txt) {
      if (txt.length > 8) {
        return 15;
      } else {
        return 18;
      }
    },
    getBannerList() {
      bannerList(this.imgqueryParams).then((res) => {
        if (res.total > 0) {
          this.backgroundImg = res.rows[0].picUrl;
        }
      });
    },
    option(e, txt) {
      this.op = e;
      if (e == 0) {
        this.queryParams = {
          pageNum: 1,
          pageSize: 12,
          orderByColumn: "sort",
        };
      } else {
        this.queryParams.bigType = e;
      }

      this.getProjectList();
    },
    getProjectList() {
      projectList(this.queryParams).then((res) => {
        this.projectList = res.rows;
        this.total = res.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.project_type_list {
  width: 100%;
  height: 100px;
  margin: auto;
  background: #d6d6d6;
  ul li {
    float: left;
    width: 20%;
    text-align: center;
    // line-height: 100px;
    position: relative;
    cursor: pointer;
    // color: orange;
    .lit_title {
      width: 90%;
      height: 100px;
      margin: auto;
      .lit_icon {
        width: 100%;
        height: 50px;
        .iconfont {
          font-size: 30px;
        }
      }
    }
  }
  ul li:hover {
    color: #651984;
  }
}
.option {
  color: #651984;
}
.title_text {
  width: 100%;
  height: 80px;
  text-align: center;
  line-height: 80px;
  font-size: 28px;
  color: #333;
}
.title_text::before {
  content: "";
  display: block;
  width: 60px;
  height: 4px;
  background: #0a529b;
  position: relative;
  top: 70px;
  left: 48.2%;
}
.project_all {
  width: 100%;
  //   height: 500px;
}

.zhe {
  width: 100%;
  height: auto;
  background: rgba(10, 82, 155, 0.9);
  position: absolute;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  bottom: 0px;
  transition: 0.5s;
  color: #fff;
  opacity: 0;
  overflow: hidden;
  text-align: center;
  .text {
    padding: 10px;
    width: 100%;
    .title {
      width: 100%;
      height: 50px;
      line-height: 50px;
      display: block;
      font-size: 22px;
    }
    .guige {
      width: 100%;
      height: auto;
      //   line-height: 80px;
      display: block;
      font-size: 16px;
    }
    p {
      color: #fff;
      border-bottom: 1px solid rgba(255, 255, 255, 0.548);

      .icon-chakan {
        font-size: 30px;
      }
    }
    :last-child {
      border-bottom: none;
    }
  }
}
.hh:hover .zhe {
  opacity: 1;
  bottom: 0px;
}
</style>